//Standard libraries
import React, { useEffect, useState } from "react";
import { StyledTypography, StyledBox } from "../../../styled-mui";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { TYPE_CARD } from "../../../constants/catalog";
import { StyledProductIndispensable } from "./styled-productIndispensable";
import PdpProductCard from "../pdp-product-card/PdpProductCard";

interface ProductIndispensableProps {
  product: any;
  productMerchandisingAssociation: any;
  productPartNumber: any;
  displayPartNumber: string;
  promotion: any;
  displayOfferPrice: number;
  displayListPrice: number;
  currentSelection: any;
  updateProductQuantity: (n: number) => void;
  addToCart: (bundle: any, isIndispensable?: boolean) => void;
  inventoryAvailableFlag: boolean;
  buyableFlag: boolean;
  translation: any;
  loginStatus: boolean;
  isB2B: boolean;
  SIGNIN: string;
  selectedIndispensables: any[];
  setSelectedIndispensables: React.Dispatch<React.SetStateAction<any[]>>;
  isCartConfirmModal?: boolean;
}

/**
 * ProductIndispensable component
 *
 * @param product
 * @param props
 */
const ProductIndispensable: React.FC<ProductIndispensableProps> = ({
  product,
  productMerchandisingAssociation,
  addToCart,
  inventoryAvailableFlag,
  buyableFlag,
  currentSelection,
  displayOfferPrice,
  selectedIndispensables,
  setSelectedIndispensables,
  isCartConfirmModal = false,
}) => {
  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slides: {
      perView: productMerchandisingAssociation?.length === 1 ? 2 : 3,
      spacing: 20,
    },
    breakpoints: {
      "(max-width: 767px)": {
        slides: { perView: 1.4, spacing: 12 },
      },
      "(min-width: 768px) and (max-width: 960px)": {
        slides: { perView: 2.4, spacing: 10 },
      },
    },
  });
  const [disable, setDisable] = useState<boolean>(false);
  useEffect(() => setDisable(false), [productMerchandisingAssociation.length]);

  // const handlerAddToCart = () => {
  //   const catentField1Raw = product?.UserData?.[0]?.["custom.fields.*"]?.[0]?.catent_field1?.raw ?? null;

  //   // ONLY selected products
  //   const selectedRaws = productsSelected
  //     .map((item) => {
  //       const userData = item?.UserData?.[0];
  //       const customFields = userData?.["custom.fields.*"]?.[0];
  //       return customFields?.catent_field1?.raw ?? null;
  //     })
  //     .filter(Boolean);

  //   const products = [catentField1Raw, ...selectedRaws];

  //   addToCart && addToCart(products, true);
  // };

  // const handlerSelected = (action, product) => {
  //   if (action === "add") {
  //     setProductSelected([...productsSelected, product]);
  //   } else {
  //     setProductSelected(productsSelected.filter((pdt) => pdt.name !== product.name));
  //   }
  // };

  // const handlerAddToCart = () => {
  //   // MAIN product (always)
  //   const mainProductRaw = product?.UserData?.[0]?.["custom.fields.*"]?.[0]?.catent_field1?.raw;

  //   // Selected indispensable products
  //   const selectedProductsRaw = productsSelected
  //     .map((item) => {
  //       const customFields = item?.UserData?.[0]?.["custom.fields.*"]?.[0];
  //       return customFields?.catent_field1?.raw ?? null;
  //     })
  //     .filter(Boolean);

  //   // Final bundle
  //   const products = [mainProductRaw, ...selectedProductsRaw].filter(Boolean);

  //   addToCart(products, true);
  // };

  const handlerSelected = (action: string, product: any) => {
    if (action === "add") {
      setSelectedIndispensables((prev) => [...prev, product]);
    }

    if (action === "remove") {
      setSelectedIndispensables((prev) => prev.filter((p) => p.partNumber !== product.partNumber));
    }
  };
  return (
    <StyledProductIndispensable>
      {/*<StyledBox className="product-indispensable" ref={sliderRef}>
         <StyledGrid item xs={12} sm={8} lg={7} pr={{ xs: 5, sm: 0 }} sx={{ textAlign: "center" }}>
              <StyledTypography variant="h4" component="h4" pb={2} className="uppercase">
                {t("ProductEssential.MainTitle")}
              </StyledTypography>
              <StyledTypography variant="body2" component="p" className="">
                {t("ProductEssential.Text")}
              </StyledTypography>
            </StyledGrid> */}
      {/* <ProductCard
          key={selectedSku?.partNumber || product.partNumber}
          product={productForCard}
          type={TYPE_CARD.INDISPENSABLE}
          defaultProduct
          showAttribute
          attributes={currentSelection.selectedAttributes}
        /> */}
      <StyledBox
        className={`product-indispensable${isCartConfirmModal ? " cart-modal" : " "}`}
        ref={sliderRef}
        sx={
          isCartConfirmModal
            ? {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: {
                  xs: "0 12px 32px 12px",
                  sm: "0 12px 32px 12px",
                  md: "0 80px 32px 80px",
                },
                width: "100%",
                background: "#fff",
                boxSizing: "border-box",
                borderRadius: "8px",
                marginTop: "24px",
                marginBottom: "24px",
              }
            : {}
        }>
        {isCartConfirmModal ? (
          <>
            <StyledTypography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "24px",
                color: "#1A1A1A",
                marginBottom: "4px",
              }}>
              Attendez !
            </StyledTypography>
            <StyledTypography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 400,
                fontSize: "15px",
                lineHeight: "24px",
                color: "#1A1A1A",
                marginBottom: "24px",
              }}>
              Ne passez pas à côté des indispensables pour votre produit.
            </StyledTypography>
          </>
        ) : (
          <>
            <StyledBox
              sx={{
                borderRadius: "8px",
                backgroundColor: "#EFF3F6",
                pb: 3,
                width: "100%",
              }}>
              <StyledTypography
                sx={{
                  fontWeight: 700,
                  fontSize: "13.3px",
                  textTransform: "uppercase",
                  color: "#000",
                }}>
                Le Pack Indispensable
              </StyledTypography>
            </StyledBox>

            {/* <StyledTypography
              sx={{
                color: "#1A1A1A",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                marginBottom: "12px",
              }}>
              Type de poignée
            </StyledTypography> */}
          </>
        )}
        {productMerchandisingAssociation?.map((product, index) => (
          <StyledBox key={index} sx={{ width: "100%", marginBottom: "10px", background: "#ffffff" }}>
            <PdpProductCard
              product={isCartConfirmModal ? { ...product, localQuantity: 1 } : product}
              productPosition={index}
              type={TYPE_CARD.INDISPENSABLE}
              onSelect={handlerSelected}
              onAddToCart={addToCart}
              showAttribute={true}
              isCartConfirmModal={isCartConfirmModal}
              disable={disable}
              setDisable={setDisable}
            />
          </StyledBox>
        ))}

        {/* <StyledGrid
                md={3}
                xs={12}
                item
                pr={5}
                sx={{
                  position: "relative",
                  textAlign: "center",
                }}>
                <StyledTypography variant="h5" color="tertiary.main" component="h5" p={5} className="uppercase">
                  {t("ProductEssential.Title")}
                </StyledTypography>
                <FormattedPriceDisplay variant="h2" min={getTotal()} color="tertiary.main" sup={true} />
                <StyledTypography
                  variant="caption"
                  color="tertiary.main"
                  component="div"
                  pb={{ xs: 10, sm: 17 }}
                  px={5}
                  style={{ display: "inline-flex" }}>
                  {t("EcoPart")}&nbsp;
                  <FormattedPriceDisplay variant="caption" color="tertiary.main" min={getTotalEcoPart()} />
                </StyledTypography>
                <Hidden mdDown>
                  <SvgProjectIndispensable />
                </Hidden>
              </StyledGrid> */}
        {/* <StyledButton
          className="product-indispensable-button"
          startIcon={<SvgShoppingCart />}
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            handlerAddToCart();
          }}
          disabled={!buyableFlag || !displayOfferPrice}
          sx={{ width: { xs: "100%", sm: "auto", mt: 5 } }}>
          {t("ProductEssential.Action")}
        </StyledButton> */}
      </StyledBox>
    </StyledProductIndispensable>
  );
};

export default ProductIndispensable;
